import { render } from "./OktaLogo.vue?vue&type=template&id=08c7c606"
import script from "./OktaLogo.vue?vue&type=script&lang=js"
export * from "./OktaLogo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__